/**
 * Masks a sensitive value, revealing it on click of an eye toggle button.
 *
 * Example:
 *  .d-flex.align-items-center.gap-2{data: {controller: "obfuscate-value"}}
 *    %span{data: {"obfuscate-value-target": "display", "obfuscate-value-raw-value": user.nu_status_number}}
 *    %button{type: "button", "data-action": "obfuscate-value#toggle"}
 *      %span{"data-obfuscate-value-target": "icon"}= ns_uic1(:icon, name: "eye")
 *      %span.d-none{"data-obfuscate-value-target": "icon"}= ns_uic1(:icon, name: "eye-slash")
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["display", "icon"];
  static values = { raw: String };

  connect() {
    this.revealed = false;
    this.render();
  }

  toggle(event) {
    event.preventDefault();

    this.revealed = !this.revealed;
    this.render();

    this.iconTargets.forEach((icon) => icon.classList.toggle("d-none"));
  }

  render() {
    if (this.hasRawValue) {
      this.iconTarget.classList.remove("d-none");
      this.displayTarget.textContent = this.revealed
        ? this.rawValue
        : this.maskedValue();
    } else {
      this.displayTarget.textContent = "";
      this.iconTarget.classList.add("d-none");
    }
  }

  maskedValue() {
    return this.rawValue.length > 4
      ? `******${this.rawValue.slice(-4)}`
      : "******";
  }
}
